const config = {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000', // Default to localhost if not provided
};

export default config;